
import React from 'react';
import PageHeader from '../common/PageHeader';

const Competitor360Header = () => {
  return (
    <PageHeader 
      pageTitle="Competitor 360" 
      mainTitle="Competitor Intelligence"
      description="Analyze competitor performance, pricing, and strategies"
      showBackButton={true}
    />
  );
};

export default Competitor360Header;
